import { render, staticRenderFns } from "./UploadableNamedImage.vue?vue&type=template&id=65b15546&scoped=true&"
import script from "./UploadableNamedImage.vue?vue&type=script&lang=js&"
export * from "./UploadableNamedImage.vue?vue&type=script&lang=js&"
import style0 from "./UploadableNamedImage.vue?vue&type=style&index=0&id=65b15546&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b15546",
  null
  
)

export default component.exports